import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Dropdown } from '../../components'
import { FilterContainer } from './styled'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { Input } from 'antd'
import { debounce } from 'lodash'
import './style.scss'
const { Search } = Input

const Filter = ({
  data,
  isWorkshop,
  children,
  defaultValue,
  label,
  noIndent,
  propKey = 'text',
  style,
  callback,
  onChangeSearch
}) => {
  const { t } = useTranslation()
  const [selectedItem, setSelectedItem] = useState(defaultValue)

  useEffect(() => {
    setSelectedItem(defaultValue)
  }, [defaultValue])

  const handleChangeItem = item => {
    setSelectedItem(item[propKey])
    if (callback) {
      callback(item)
    }
  }
  const debouncedSearch = useCallback(
    debounce(value => onChangeSearch(value), 300),
    []
  )
  return (
    <FilterContainer noIndent={noIndent} style={style}>
      <FilterContainer.Wrapper>{children}</FilterContainer.Wrapper>
      <div className="shl-left-line"></div>
      <div className="sort-by-date-wrap">
        <FilterContainer.Wrapper>
          {isWorkshop && (
            <Search
              allowClear
              placeholder={t('v2:search')}
              onChange={e => debouncedSearch(e.target.value)}
              className="workshop-search"
              style={{ width: 220 }}
            />
          )}
          <FilterContainer.Label>{label}</FilterContainer.Label>
          <Dropdown
            list={
              <FilterContainer.Menu>
                {data
                  .filter(item => item[propKey] !== selectedItem)
                  .map((item, index) => (
                    <FilterContainer.Item key={index}>
                      <FilterContainer.Link
                        className="date-sort-by"
                        onClick={() => handleChangeItem(item)}
                      >
                        {t(item[propKey])}
                      </FilterContainer.Link>
                    </FilterContainer.Item>
                  ))}
              </FilterContainer.Menu>
            }
          >
            <FilterContainer.Selected>
              {t(selectedItem)}
            </FilterContainer.Selected>
          </Dropdown>
        </FilterContainer.Wrapper>
      </div>
    </FilterContainer>
  )
}

Filter.propTypes = {
  data: PropTypes.array,
  bordered: PropTypes.bool,
  children: PropTypes.node,
  defaultValue: PropTypes.string,
  propKey: PropTypes.string,
  style: PropTypes.object,
  label: PropTypes.string,
  noIndent: PropTypes.bool,
  t: PropTypes.func.isRequired,
  callback: PropTypes.func
}

export default Filter
